export default __webpack_public_path__ + "static/media/premium-clock-icon-inspire.b8e5bb0749c6a09a3805785cfe78103f.svg";